import strapi, { mapStrapiData } from '../lib/strapi';
import qs from 'qs';

export const getTechPageData = async () => {
  try {
    const query = qs.stringify({
      populate: {
        hero_Image: true,
        widya_connect_features: { populate: '*' },
        widya_connect_logo: true,
        harvest_flow_features: { populate: '*' },
        harvest_flow_logo: true,
        matching_engine_image: true
      }
    });
    
    const response = await strapi.get(`/technology-page?${query}`);
    return mapStrapiData(response);
  } catch (error) {
    console.error('Error fetching Technology Page data:', error);
    return null;
  }
};